import React from 'react';

import { faInstagram } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans } from '@lingui/macro';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';

import FormInlineButton from '../../../misc/FormInlineButton';

const id = 'instagram';
const name = 'Instagram';
const version = '1.1';
const stream_key_link = 'https://about.instagram.com/blog/tips-and-tricks/instagram-live-producer';
const description = <Trans>Live-Streaming to Instagram Live RTMP Service.</Trans>;
const image_copyright = '';
const author = {
	creator: {
		name: 'datarhei',
		link: 'https://github.com/datarhei',
	},
	maintainer: {
		name: 'datarhei',
		link: 'https://github.com/datarhei',
	},
};
const category = 'platform';
const requires = {
	protocols: ['rtmps'],
	formats: ['flv'],
	codecs: {
		audio: ['aac', 'mp3'],
		video: ['h264'],
	},
};

function ServiceIcon(props) {
	return <FontAwesomeIcon icon={faInstagram} style={{ color: '#E1306C' }} {...props} />;
}

function init(settings) {
	const initSettings = {
		key: '',
		service_instafeed: false,
		service_yellowduck: false,
		...settings,
	};

	return initSettings;
}

function Service({ settings = {}, skills = {}, metadata = {}, streams = [], onChange = function (output, settings) {} }) {
	settings = init(settings);

	const handleChange = (what) => (event) => {
		const value = event.target.value;

		settings[what] = value;

		const output = createOutput(settings);

		onChange([output], settings);
	};

	const createOutput = (settings) => {
		const output = {
			address: 'http://instagram.com:443/rtmp/' + settings.key,
			options: ['-f', 'flv'],
		};

		return output;
	};

	return (
		<Grid container spacing={2}>
			<Grid item xs={12} md={9}>
				<TextField
					variant="outlined"
					fullWidth
					label={<Trans>Stream key</Trans>}
					placeholder="IG-10101942686003993-0-AbyaAF64MLbaxSBJ"
					value={settings.key}
					onChange={handleChange('key')}
				/>
			</Grid>
			<Grid item xs={12} md={3}>
				<FormInlineButton target="blank" href={stream_key_link} component="a">
					<Trans>GET</Trans>
				</FormInlineButton>
			</Grid>
		</Grid>
	);
}

export { id, name, version, stream_key_link, description, image_copyright, author, category, requires, ServiceIcon as icon, Service as component };
